module.exports = __webpack_public_path__ + "img/ms_b3_img2.ed33f491.png";